import { render, staticRenderFns } from "./ExpensesTypeCards.vue?vue&type=template&id=2a29df27&"
import script from "./ExpensesTypeCards.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports